interface WebKeyValueStore {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

const createMemoryKeyValueStore = (): WebKeyValueStore => {
  const items = new Map<string, string>();

  return {
    getItem: (key) => items.get(key) ?? null,
    setItem: (key, value) => {
      items.set(key, value);
    },
  };
};

const resolveWebKeyValueStore = (): WebKeyValueStore => {
  if (typeof localStorage === 'undefined') {
    return createMemoryKeyValueStore();
  }

  return localStorage;
};

export { createMemoryKeyValueStore, resolveWebKeyValueStore };
export type { WebKeyValueStore };
